export function createUniqueGroupId() {
	const date = new Date();

	return `${ date.getUTCMonth() }_${ date.getUTCDate() }_${ date.getUTCDay() }_${ date.getUTCFullYear() }_${ date.getUTCMilliseconds() }_${ date.getTime() }`;
}
